import React, { Component } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import queryString from 'query-string'
import { Form as UnstyledForm } from 'formsy-react-2'
import { Table, TableHeader, TableLoading, Button, Pagination, TextInput, Select, Colors } from 'advenio-components'
import AdvancedSearchActions from '../../Data/Redux/AdvancedSearchRedux'
import AllCentersActions from '../../Data/Redux/AllCentersRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'
import CenterProductsActions from '../../Data/Redux/CenterProductsRedux'
import ValidatedReceiptsActions from '../../Data/Redux/ValidatedReceiptsRedux'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'
import ParentPaymentTypesActions from '../../Data/Redux/ParentPaymentTypesRedux'
import { stringContainsExactlyOf } from '../../utils/Utils'

const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  margin-bottom: 10px;
  background: #e4e4e6;
  border: solid transparent 1px;
  border-radius: 5px;
`
const Filters = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  height: auto;
  flex-direction: column;
`

const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: auto;
`

const Form = styled(UnstyledForm)`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const Send = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 5px;
`
const InputContainer = styled.div`
  margin-right: 5px;
  flex: 1;
`

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  `

const TableContainer = styled.div`
  width: 100%;
  padding: 16px 32px;
  box-sizing: border-box;
`

const HeaderContainer = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  white-space: normal;
  height: 90px;
  ${({ deleted, status }) => {
    if(deleted){
      return `background-color:${Colors.red300};`
    } 
    if(stringContainsExactlyOf(status,[2,4])){
      return `background-color:${Colors.yellow300};`
    } 
  }}
`
const NewCell = styled(CellContainer)`
  justify-content: center;
  align-items: center;
  ${({ deleted }) => deleted && `
    background-color:${Colors.red300};
  `}
`
const Type = styled.span`
  padding: 10px 30px 10px 30px;
  background-color: #CCCCCC;
  border-radius: 20px;
  color: #FFF;
`

const Without = styled.span`
  font-style: italic;
  font-size: 16px;
  color: #797979;
`

const Parents = styled.div`
  display: flex;
  justify-content: space-between;
  height: auto;
  flex-direction: column;
`

const PaginationContainer = styled.div`
  margin: 8px 0;
`

class AdvancedSearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      firstPageToRender: 1,
      lastPageToRender: 10,
      pageSelected: 1,
      queryParams: {},
      params: {},
    }
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)
    this.setState({
      params: queryParams,
    })
    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }
    const queries = R.clone(queryParams)
    Object.keys(queries).map((value) => {
      if (!queryParams[value] || queryParams[value] === '' || queryParams[value] === ' ' || queryParams[value] === 0 || queryParams[value] === '0') {
        delete queries[value]
      }
    })
    this.setState({ queryParams })
    this.props.getAdvancedSearch(queries)
    this.props.getAllCenters()
    this.props.setValidateReceipts()
  }

  onFilter = (query) => {
    const queries = R.clone(query)
    Object.keys(queries).map((value) => {
      if (!query[value] || query[value] === '' || query[value] === ' ' || query[value] === 0 || query[value] === '0') {
        delete queries[value]
      }
    })
    this.setState({queryParams:queries,pageSelected:1});
    this.props.getAdvancedSearch(queries)
    this.props.goTo(`?${queryString.stringify(queries)}`)
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { getAdvancedSearch, goTo } = this.props

      const queries = { ...queryParams, page }
      getAdvancedSearch(queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  getCenter = (center) => {
    if (center) {
      return (
        <Type>{center.abbreviation}</Type>
      )
    }
    return (
      <Without>Sin centro</Without>
    )
  }
  getStatus = (status, deleted) => {
    if(deleted){
      return (
        <Type>Alumno No Activo</Type>
      )
    }
    if (status) {
      return (
        <Type>{status}</Type>
      )
    }
    return (
      <Without>Sin Estatus</Without>
    )
  }

  getName = (name) => {
    if (name) {
      return (
        <span>{name}</span>
      )
    }
    return (
      <Without>Sin Nombre</Without>
    )
  }

  getParents = (parents) => {
    const parentsToRender = parents.map(
      currentValue => <span key={currentValue.id}>{`${currentValue.full_name || ''}`}</span>)
    return (
      <Parents>
        {parentsToRender}
      </Parents>
    )
  }

  sendToProfile = (center, id, classroom_id) => {
    const { goTo, setActiveStudentId, setActiveClassroomId,setUserCenterid ,centerid} = this.props
    setActiveStudentId(Number(id))
    setActiveClassroomId(Number(classroom_id))
    setUserCenterid(Number(center.id))
    if (id !== this.props.studentid || centerid ===0){
      this.chargeAll(Number(center.id,id));
    }
    goTo(`/classroom/${classroom_id}/student/${id}`)
  }
  
  chargeAll (centerid,id) {
      this.props.getCompany()
      this.props.getCenterProducts(centerid);
      this.props.getCenterClassroom(centerid);
      this.props.getCenterStudyPrograms(centerid);
      this.props.getCenterPaymentTypes(centerid);
  }
  
  renderCenterOptions = () => {
    const newCenters = R.clone(this.props.centers)
    const centersToRender = newCenters.map(center => ({
      id: center.id.toString(),
      label: `${center.name} (${center.abbreviation})`,
      value: center.id.toString(),
    }))
    centersToRender.unshift({ id: '', value: 0, label: 'Todos' })
    return centersToRender
  }

  render() {
    const { advanced_search, loading, meta, error } = this.props
    const { pageSelected, params } = this.state
    const centers = this.renderCenterOptions()
    return (
      <Container>
        <TableContainer>
          <HeaderContainer>
            <h1 style={{ marginRight: '5px' }} >Búsqueda de Niños</h1>
          </HeaderContainer>
          <FilterContainer>
            <Form onSubmit={this.onFilter}>
              <Filters>
                <FiltersContainer>
                  <InputContainer>
                    <TextInput
                      name="parent_name"
                      label="Nombre del Tutor"
                      value={params.parent_name || ''}
                    />
                  </InputContainer>
                  <InputContainer>
                    <TextInput
                      name="student_name"
                      label="Nombre del niño"
                      value={params.student_name || ''}
                    />
                  </InputContainer>
                  <InputContainer>
                    <Select
                      name="center_id"
                      label="Centro"
                      value={params.center_id ? Number(params.center_id) : ' '}
                      options={centers}
                      hideEmptyHelpBlock
                    />
                  </InputContainer>
                </FiltersContainer>
              </Filters>
              <Send>
                <Button marginRight="0" loading={loading} primary small type="submit">Filtrar</Button>
              </Send>
            </Form>
          </FilterContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {loading ?
            <TableLoading
              roundedCorners
              withBorder
              columns={[
                {
                  id: 1,
                  header: 'Nombre Alumno',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 2,
                  header: 'Nombre Tutor',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 3,
                  header: 'Centro',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 4,
                  header: 'Estatus',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 5,
                  header: '',
                  element: 'Text',
                  center: true,
                },
              ]}
              rows={10}
            />
            :
            <Table
              data={error ? [] : advanced_search}
              style={{ width: '100%' }}
              roundedCorners
              withBorder
              columns={[
                {
                  id: '1',
                  Header: () => <TableHeader title="Nombre Alumno" center blue />,
                  accessor: ({ full_name, status:{id:status_id}, deleted_at }) => ({ full_name, deleted_at,status_id }),
                  Cell: ({ value: { full_name, deleted_at, status_id } }) =>
                    <CellContainer deleted={deleted_at} status={status_id}>{this.getName(full_name)}</CellContainer>,
                  minWidth: 300,
                },
                {
                  id: '2',
                  Header: () => <TableHeader title="Nombre Tutor" center blue />,
                  accessor: ({ parents, deleted_at, status:{id:status_id} }) => ({ parents, deleted_at, status_id }),
                  Cell: ({ value: { parents, deleted_at, status_id } }) => <NewCell deleted={deleted_at} status={status_id} >{this.getParents(parents)}</NewCell>,
                  minWidth: 300,
                },
                {
                  id: '3',
                  Header: () => <TableHeader title="Centro" center blue />,
                  accessor: ({ center, deleted_at, status:{id:status_id} }) => ({ center, deleted_at, status_id }),
                  Cell: ({ value: { center, deleted_at, status_id } }) =>
                    <CellContainer deleted={deleted_at} status={status_id} >{this.getCenter(center)}</CellContainer>,
                  minWidth: 150,
                },
                {
                  id: '4',
                  Header: () => <TableHeader title="Estatus" center blue />,
                  accessor: ({ center, deleted_at, status:{id:status_id, description} }) => ({ center, deleted_at, status_id, description }),
                  Cell: ({ value: { center, deleted_at, status_id, description} }) =>
                    <CellContainer deleted={deleted_at} status={status_id} >{this.getStatus(description,deleted_at)}</CellContainer>,
                  minWidth: 300,
                },
                {
                  id: '5',
                  Header: () => <TableHeader title="" center blue />,
                  accessor: ({ center, id, classroom_id, deleted_at, status:{id:status_id} }) => ({ center, id, classroom_id, deleted_at, status_id }),
                  Cell: ({ value: { center, id, classroom_id, deleted_at, status_id } }) => (
                    <CellContainer deleted={deleted_at} status={status_id} >
                      <Button danger={!deleted_at} onClick={() => this.sendToProfile(center, id, classroom_id)}>
                        Ver Perfil
                      </Button>
                    </CellContainer>
                  ),
                  minWidth: 300,
                },
              ]}
            />
          }
        </TableContainer>
      </Container>
    )
  }
}

AdvancedSearch.propTypes = {
  loading: PropTypes.bool.isRequired,
  advanced_search: PropTypes.array,
  getAdvancedSearch: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  setActiveClassroomId: PropTypes.func.isRequired,
  setActiveStudentId: PropTypes.func.isRequired,
  setUserCenterid: PropTypes.func.isRequired,
  setValidateReceipts: PropTypes.func.isRequired,
  getAllCenters: PropTypes.func.isRequired,
  getCenterClassroom: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  studentid: PropTypes.number.isRequired,
    /** Fetch a listing of all available payment types */
  getCenterPaymentTypes: PropTypes.func.isRequired,
  centers: PropTypes.array,
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
}

AdvancedSearch.defaultProps = {
  advanced_search: [],
  centers: [],
  meta: () => {},
  location: {},
}

const mapStateToProps = ({ advanced_search, allCenters,...state }) => ({
  advanced_search: advanced_search.get.results.data,
  centers: allCenters.get.results,
  meta: advanced_search.get.results.meta,
  links: advanced_search.get.results.links,
  loading: advanced_search.get.fetching,
  error: advanced_search.get.error,
  studentid:state.classrooms.activeStudentId,
  centerid:state.classrooms.center_id,
})

const mapDispatchToProps = dispatch => ({
  getAdvancedSearch: query => dispatch(AdvancedSearchActions.getRequest(query)),
  goTo: path => dispatch(push(path)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setUserCenterid: id => dispatch(ClassroomActions.setUserCenterid(id)),
  setValidateReceipts: () => dispatch(ValidatedReceiptsActions.unValidateError()),
  getAllCenters: () => dispatch(AllCentersActions.getRequest()),
  getCenterClassroom: centerId => dispatch(ClassroomActions.getClassroomRequest(centerId)),
  getCompany: centerId => dispatch(CompaniesActions.getRequest()),
  getCenterProducts: centerId => dispatch(CenterProductsActions.getRequest(centerId)),
  getCenterStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId,true)),
  getCenterPaymentTypes: centerId => dispatch(ParentPaymentTypesActions.getParentPaymentRequest(centerId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdvancedSearch))



// WEBPACK FOOTER //
// ./src/Containers/AdvancedSearch/index.jsx